import { IssuedPeakAccountStatusType, PeakSource } from "@/enums/enums";
import { SalaryDetailModel, SalaryEWFDetailModel } from "@/model/salary/salaryDetailModel";
import { PaymentModel } from "@/model/salary/salaryModel";

export function GetCreateExpenseFromPayRunRequest(input: {
  salary: SalaryEWFDetailModel;
  payment: PaymentModel;
  issuedSalaryExpenseStatusType: IssuedPeakAccountStatusType;
  isUpdateTimezone: boolean;
}) {
  return {
    salary: {
      id: input.salary.id,
      number: input.salary.number,
      issuedDate: input.salary.issuedDate,
      dueDate: input.salary.dueDate,
      fromDate: input.salary.fromDate,
      toDate: input.salary.toDate,
      status: input.salary.status,
      salaryTotal: input.salary.salaryTotal,
      revenueTotal: input.salary.revenueTotal,
      deductionTotal: input.salary.deductionTotal,
      whtPayableTotal: input.salary.whtPayableTotal,
      socialSecurityPayableTotal: input.salary.socialSecurityPayableTotal,
      socialSecurityEmployeeTotal: input.salary.socialSecurityEmployeeTotal,
      socialSecurityEmployerTotal: input.salary.socialSecurityEmployerTotal,
      whtTotal: input.salary.whtTotal,
      netAmount: input.salary.netAmount,
      taxCalculatedAmount: input.salary.taxCalculatedAmount,
      socialSecurityCalculatedAmount: input.salary.socialSecurityCalculatedAmount,
      grossSalaryAmount: input.salary.grossSalaryAmount,
      regularTotal: input.salary.regularTotal,
      irregularTotal: input.salary.irregularTotal,
      employeeList: input.salary.employeeList,
      salaryPaymentDate: input.salary.salaryPaymentDate ?? null,
      salaryExpenseId: input.salary.salaryExpenseId ?? 0,
      salaryExpenseNumber: input.salary.salaryExpenseNumber,
      issuedSalaryExpenseStatusType: input.salary.issuedSalaryExpenseStatusType,
      ssoExpenseId: input.salary.ssoExpenseId ?? 0,
      ssoExpenseNumber: input.salary.ssoExpenseNumber,
      employeeWelfareFundPayableTotal: input.salary.employeeWelfareFundPayableTotal,
      employeeWelfareFundEmployeeTotal: input.salary.employeeWelfareFundEmployeeTotal,
      employeeWelfareFundEmployerTotal: input.salary.employeeWelfareFundEmployerTotal,
    },
    payment: input.payment,
    issuedSalaryExpenseStatusType: input.issuedSalaryExpenseStatusType,
    isUpdateTimezone: input.isUpdateTimezone,
    source: PeakSource.PeakPayroll,
  };
}

export function GetPaidExpenseFromPayrollRequest(input: { expenseId: number; payment: PaymentModel }) {
  return {
    expenseId: input.expenseId,
    payment: input.payment,
    source: PeakSource.PeakPayroll,
  };
}

export function GetCreateExpenseFromSSORequest(input: { salary: SalaryDetailModel; payment: PaymentModel }) {
  return {
    salary: {
      id: input.salary.id,
      number: input.salary.number,
      issuedDate: input.salary.issuedDate,
      dueDate: input.salary.dueDate,
      fromDate: input.salary.fromDate,
      toDate: input.salary.toDate,
      status: input.salary.status,
      salaryTotal: input.salary.salaryTotal,
      revenueTotal: input.salary.revenueTotal,
      deductionTotal: input.salary.deductionTotal,
      whtPayableTotal: input.salary.whtPayableTotal,
      socialSecurityPayableTotal: input.salary.socialSecurityPayableTotal,
      socialSecurityEmployeeTotal: input.salary.socialSecurityEmployeeTotal,
      socialSecurityEmployerTotal: input.salary.socialSecurityEmployerTotal,
      whtTotal: input.salary.whtTotal,
      netAmount: input.salary.netAmount,
      taxCalculatedAmount: input.salary.taxCalculatedAmount,
      socialSecurityCalculatedAmount: input.salary.socialSecurityCalculatedAmount,
      grossSalaryAmount: input.salary.grossSalaryAmount,
      regularTotal: input.salary.regularTotal,
      irregularTotal: input.salary.irregularTotal,
      employeeList: input.salary.employeeList,
      salaryPaymentDate: input.salary.salaryPaymentDate ?? null,
      salaryExpenseId: input.salary.salaryExpenseId ?? 0,
      salaryExpenseNumber: input.salary.salaryExpenseNumber,
      issuedSalaryExpenseStatusType: input.salary.issuedSalaryExpenseStatusType,
      ssoExpenseId: input.salary.ssoExpenseId ?? 0,
      ssoExpenseNumber: input.salary.ssoExpenseNumber,
    },
    payment: input.payment,
    source: PeakSource.PeakPayroll,
  };
}

export function GetCreateExpenseFromEWFRequest(input: { salary: SalaryDetailModel; payment: PaymentModel }) {
  return {
    salary: {
      id: input.salary.id,
      number: input.salary.number,
      issuedDate: input.salary.issuedDate,
      dueDate: input.salary.dueDate,
      fromDate: input.salary.fromDate,
      toDate: input.salary.toDate,
      status: input.salary.status,
      salaryTotal: input.salary.salaryTotal,
      revenueTotal: input.salary.revenueTotal,
      deductionTotal: input.salary.deductionTotal,
      whtPayableTotal: input.salary.whtPayableTotal,
      socialSecurityPayableTotal: input.salary.socialSecurityPayableTotal,
      socialSecurityEmployeeTotal: input.salary.socialSecurityEmployeeTotal,
      socialSecurityEmployerTotal: input.salary.socialSecurityEmployerTotal,
      employeeWelfareFundPayableTotal: input.salary.employeeWelfareFundPayableTotal,
      employeeWelfareFundEmployeeTotal: input.salary.employeeWelfareFundEmployeeTotal,
      employeeWelfareFundEmployerTotal: input.salary.employeeWelfareFundEmployerTotal,
      whtTotal: input.salary.whtTotal,
      netAmount: input.salary.netAmount,
      taxCalculatedAmount: input.salary.taxCalculatedAmount,
      socialSecurityCalculatedAmount: input.salary.socialSecurityCalculatedAmount,
      grossSalaryAmount: input.salary.grossSalaryAmount,
      regularTotal: input.salary.regularTotal,
      irregularTotal: input.salary.irregularTotal,
      employeeList: input.salary.employeeList,
      salaryPaymentDate: input.salary.salaryPaymentDate ?? null,
      salaryExpenseId: input.salary.salaryExpenseId ?? 0,
      salaryExpenseNumber: input.salary.salaryExpenseNumber,
      issuedSalaryExpenseStatusType: input.salary.issuedSalaryExpenseStatusType,
      ssoExpenseId: input.salary.ssoExpenseId ?? 0,
      ssoExpenseNumber: input.salary.ssoExpenseNumber,
    },
    payment: input.payment,
    source: PeakSource.PeakPayroll,
  };
}
